import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  input,
  Input,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { Message } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';

@Component({
  selector: 'osp-messages',
  standalone: true,
  imports: [MessagesModule, CommonModule],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MessagesComponent {
  @HostBinding('class') protected hostClass = 'osp-messages';

  @ContentChild(TemplateRef) template!: TemplateRef<unknown>;

  protected formattedMessages: Message[] = [];

  @Input() set messages(messages: Message[] | string[]) {
    this.formattedMessages = messages.map((msg) => {
      if (typeof msg === 'string') return this.convertStringToInfoMessage(msg);

      if (!msg.severity) return this.setInfoSeverity(msg);

      return msg;
    });
  }

  @Input() key: string | undefined;
  @Input() closable = true;
  @Input() enableService = true;
  @Input() escape = true;
  @Input() severity: string | undefined;
  @Input() showTransitionOptions = '300ms ease-out';
  @Input() hideTransitionOptions = '200ms cubic-bezier(0.86, 0, 0.07, 1)';
  @Input() cssClass = '';
  $singleMessage = input<boolean>(false, { alias: 'singleMessage' });

  private convertStringToInfoMessage(message: string) {
    return {
      detail: message,
      severity: 'info',
    };
  }

  private setInfoSeverity(message: Message) {
    return {
      ...message,
      severity: 'info',
    };
  }
}
